
import React, { useEffect, useState } from 'react';
import bannerImage from './professional-payroll-services.webp';
import OnlyButtonrange from './OnlyButtonrange';
import jsPDF from "jspdf";
const Banner = () => {
    const [animate, setAnimate] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({ email: '', phone: '' });
    const [loading, setLoading] = useState(false);

    const courseDetails = {
        name: 'GST, TDS & Compliance Filing',
        description: 'GST, TDS & Compliance Filing is a specialized training module designed to equip accounting and finance professionals with practical skills in indirect and direct tax compliance. This program covers all essential aspects of Goods and Services Tax (GST) ',

        fee: '₹7000',
    };

    useEffect(() => {
        setAnimate(true);
    }, []);

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = () => {
        setStep(2);
    };

    const handleBrochureDownload = () => {
        const link = document.createElement('a');
        link.href = '/brochure.docx'; // brochure file must be in public folder
        link.setAttribute('download', 'Education-Brochure.docx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    const generatePDF = () => {


        const doc = new jsPDF();

        // Blue header bar
        doc.setFillColor(52, 152, 219); // blue color
        doc.rect(0, 10, 210, 15, 'F');

        // Main Heading (white text on blue)
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(16);
        doc.setFont("helvetica", "bold");
        doc.text("International Institute of Automation", 10, 20);

        // Sub-heading (course name) under main heading
        doc.setFontSize(12);
        doc.text("Course Name: Robotics Virtual Simulation", 10, 28);

        // Reset color for rest of the text (black)
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");

        // Company address - example, you can customize
        doc.text("1912 Harvest Lane", 10, 40);
        doc.text("New York, NY 12210", 10, 46);

        // Bill To, Ship To and Invoice Details - sample layout
        doc.setFont("helvetica", "bold");
        doc.text("Bill To", 10, 60);
        doc.text("Ship To", 70, 60);
        doc.text("Invoice #", 140, 60);

        doc.setFont("helvetica", "normal");
        doc.text("John Smith", 10, 66);
        doc.text("2 Court Square", 10, 72);
        doc.text("New York, NY 12210", 10, 78);

        doc.text("John Smith", 70, 66);
        doc.text("3787 Pineview Drive", 70, 72);
        doc.text("Cambridge, MA 12210", 70, 78);

        doc.text("US-001", 140, 66);
        doc.text("Invoice Date: 11/02/2019", 140, 72);
        doc.text("P.O.# 2312/2019", 140, 78);
        doc.text("Due Date: 26/02/2019", 140, 84);

        // Draw table headers background
        doc.setFillColor(240, 240, 240);
        doc.rect(10, 90, 190, 10, 'F');

        // Table Headers
        doc.setTextColor(0, 0, 0);
        doc.setFont("helvetica", "bold");
        doc.text("QTY", 15, 97);
        doc.text("DESCRIPTION", 40, 97);
        doc.text("UNIT PRICE", 140, 97, { align: "right" });
        doc.text("AMOUNT", 190, 97, { align: "right" });

        // Table rows
        doc.setFont("helvetica", "normal");
        const items = [
            { qty: 1, desc: "Front and rear brake cables", unitPrice: 100.00, amount: 100.00 },
            { qty: 2, desc: "New set of pedal arms", unitPrice: 15.00, amount: 30.00 },
            { qty: 3, desc: "Labor 3hrs", unitPrice: 5.00, amount: 15.00 },
        ];

        let y = 105;
        items.forEach(item => {
            doc.text(String(item.qty), 15, y);
            doc.text(item.desc, 40, y);
            doc.text(item.unitPrice.toFixed(2), 140, y, { align: "right" });
            doc.text(item.amount.toFixed(2), 190, y, { align: "right" });
            y += 10;
        });

        // Subtotal and taxes
        doc.text("Subtotal", 140, y + 5, { align: "right" });
        doc.text("145.00", 190, y + 5, { align: "right" });

        doc.text("Sales Tax 6.25%", 140, y + 12, { align: "right" });
        doc.text("9.06", 190, y + 12, { align: "right" });

        doc.setFont("helvetica", "bold");
        doc.text("TOTAL", 140, y + 20, { align: "right" });
        doc.text("$154.06", 190, y + 20, { align: "right" });

        // Signature image placeholder - you can replace this with actual image with doc.addImage()
        doc.setFont("helvetica", "normal");
        doc.text("John Smith", 140, y + 45);

        // Footer text
        doc.setFontSize(8);
        doc.text("Terms & Conditions", 10, y + 60);
        doc.text("Payment is due within 15 days.", 10, y + 65);
        doc.text("Please make checks payable to: East Repair Inc.", 10, y + 70);

        // Save the PDF
        doc.save("custom_invoice.pdf");
    };


    const initiatePayment = async () => {
        setLoading(true);

        // Payment and transaction details

        // Razorpay Payment Options for paid courses
        var options = {
            key: "rzp_test_oqm83qg9Z710lA",
            key_secret: "eaHmzOnTh2AqXLFRFWavB29c",
            amount: 1 * 100, // Convert price to paise
            currency: "INR",
            payment_capture: true,
            name: "International Institute Of Automate",
            handler: async function (response) {
                alert(
                    "Thanks For Your Interest \n Your Payment has been successfully completed"
                );
                generatePDF();
                // Call API to update payment status

            },
            notes: {
                address: "International Institute Of Automate",
            },
            theme: {
                color: "#3399cc",
            },
        };

        var pay = new window.Razorpay(options);
        pay.open();
    }


    return (
        <>
            <style>{`
        .banner-container {
          position: relative;
          width: 100%;
          height: 750px;
          overflow: hidden;
          margin-top: 0px;
        }

        .banner-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .banner-overlay {
          position: absolute;
          top: 0; left: 0;
          width: 100%; height: 100%;
          background-color: rgba(5, 42, 102, 0.5);
          z-index: 1;
        }

        .banner-text {
          position: absolute;
          bottom: 18%;
          left: 5%;
          color: white;
          z-index: 2;
          opacity: 0;
          transform: translateY(50px);
          transition: all 1s ease-out;
          max-width: 700px;
        }

        .banner-text.animate {
          opacity: 1;
          transform: translateY(0);
        }

        .banner-heading {
          font-size: 32px;
          font-weight: bold;
          margin: 0;
          font-family: sans-serif;
        }

        .banner-heading .blue {
          color: white;
          text-transform: uppercase;
        }

        .banner-heading span:last-child {
          color: orange;
        }

        .banner-subheading {
  font-size: 18px;
  font-weight: 400;
  margin-top: 15px;
  line-height: 1.6;
  text-align: justify; /* 👈 This justifies the text */
  text-justify: inter-word;
  max-width: 600px;
}

        .button-group {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  margin-top: 20px;
  flex-wrap: wrap;
}


@media (max-width: 768px) {
  .button-group {
    display: block;   
  }
}

.banner-button {
  background-color:rgb(255, 162, 0);
  color: white;
  padding: 14px 24px;         /* 👈 height aur width badh gayi */
  border-radius: 9999px;
  border: none;
  font-weight: 600;
  cursor: pointer;
  font-size: 16px;            /* 👈 text size bhi thoda bada */
  transition: background 0.3s ease;
  min-width: 140px;           /* 👈 fixed minimum width */
  text-align: center;
}

.banner-button:hover {
  background-color: #0056b3;
}


       

        .star-rating {
          color: gold;
          font-size: 1.2rem;
          margin-top: 10px;
        }

       .banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Semi-dark overlay */
}

        .popup-content {
          background: white;
          padding: 20px;
          border-radius: 10px;
          width: 100%;
          max-width: 400px;
          position: relative;
          box-shadow: 0 0 10px rgba(0,0,0,0.3);
        }

        .close-btn {
          position: absolute;
          top: 10px; right: 15px;
          font-size: 20px;
          cursor: pointer;
          color: orange;
        }

        .form-step input {
          width: 100%;
          margin: 10px 0;
          padding: 10px;
          border-radius: 5px;
          border: 1px solid #ccc;
        }

        .form-step button {
          padding: 10px;
          width: 100%;
          background-color: orange;
          color: white;
          border: none;
          border-radius: 5px;
          margin-top: 10px;
          font-weight: bold;
        }

        .pay-btn {
          background-color: orange !important;
        }

.transparent-box {
  position: absolute;
  top: 210px;
  right: 1%;
  width: 30%;
  min-height: 400px; /* increased height */
  background: rgba(255, 255, 255, 0.15);
  padding: 25px;
  color: #fff;
  border-radius: 10px;
  backdrop-filter: blur(6px);
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.transparent-box h2 {
  font-size: 24px;
  margin-bottom: 15px;
}

.event-details {
  list-style-type: none;
  padding: 0;
  margin: 0 0 20px 0;
  line-height: 1.8;
  font-size: 16px;
}

.event-details li strong {
  color: #fff;
  font-weight: 600;
}

.book-now-button {
  background-color: #ffa200;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.book-now-button:hover {
  background-color: blue;
}

@media screen and (max-width: 768px) {
  .transparent-box {
    position: relative;
    width: 90%;
    margin: 20px auto;
    top: -35;
    right: 0;
    min-height: auto;
    padding: 20px;
  }
}




        

        @media (max-width: 768px) {
          .banner-heading {
            font-size: 1.8rem;
          }
          .banner-subheading {
            font-size: 1rem;
            max-width: 90%;
          }
        }

        @media (max-width: 480px) {
          .banner-heading {
            font-size: 1.5rem;
          }
          .banner-subheading {
            font-size: 0.9rem;
          }
          .popup-content {
            max-width: 90%;
          }


/* Ensure container adapts on mobile */
@media (max-width: 768px) {
  .banner-container {
    height: auto;
    flex-direction: column;
    display: flex;
    align-items: center;
    padding-bottom: 30px;
     margin-top:-560px;
  }

  .banner-text {
    position: relative;
    bottom: auto;
    left: auto;
    transform: none;
    opacity: 1 !important;
    text-align: center;
    margin-top: 20px;
    padding: 0 15px;
  }

  .banner-heading {
    font-size: 1.6rem;
    line-height: 1.4;
  }

  .banner-subheading {
    font-size: 1rem;
    text-align: justify;
    max-width: 100%;
  }

  .transparent-box {
    position: relative;
    width: 90%;
    margin-top: 20px;
    min-height: auto;
    padding: 20px;
    top: auto;
    right: auto;
    backdrop-filter: blur(4px);
  }

  .button-group {
    justify-content: center;
  }
}


        }
      `}</style>

            <div className="banner-container">
                <img src={bannerImage} alt="Banner" className="banner-image" />
                <div className="banner-overlay"></div>

                {/* Transparent text box on right side */}
                <div className="transparent-box">
                    <h2>GST, TDS & Compliance Filing</h2>
                    <ul className="event-details">
                        <li><strong>Duration:</strong> 1 Month (60 Hours)</li>
                        <li><strong>Eligibility:</strong> B.Com/M.Com/MBA/Finance</li>
                        <li><strong>Mode:</strong> Hybrid (Online/Offline)</li>
                        <li><strong>Certification:</strong> Included</li>
                        <li><strong>Start Date:</strong> June 1, 2025</li>
                        <li><strong>Timings:</strong> 10:00 AM - 4:00 PM</li>
                        <li><strong>Fee:</strong> ₹6,000</li>
                        <li><strong>Location:</strong> Hyderabad</li>
                        <li><strong>Language:</strong> English</li>
                    </ul>
                    <button className="banner-button" onClick={() => setShowPopup(true)}>Register Now</button>
                </div>


                <div className={`banner-text ${animate ? 'animate' : ''}`}>
                    <h1 className="banner-heading">
                        
                        <span className="blue">GST, TDS & Compliance    </span>
                        <span>FILING</span>
                        
                    </h1>
                    <p className="banner-subheading">
                       GST, TDS & Compliance Filing is a specialized training module designed to equip accounting and finance professionals with practical skills in indirect and direct tax compliance. This program covers all essential aspects of Goods and Services Tax (GST) registration, return filing, input tax credit reconciliation, as well as the complete process of Tax Deducted at Source (TDS) calculation, deduction, payment, and filing.


                    </p>


                    <div style={{ marginTop: '50px' }}>
                        <div className="button-group">
                            <div className="star-rating">⭐⭐⭐⭐⭐</div>
                            <button className="banner-button" onClick={handleBrochureDownload}>Brochure</button>
                            <button className="banner-button" onClick={() => window.location.href = '/contact'}>Enquiry</button>
                            <button
                                className="banner-button"
                                onClick={() => window.open('https://play.google.com/store/apps/details?id=iia.app', '_blank')}
                            >
                                Go to App
                            </button>


                        </div>

                    </div>
                </div>

            </div>



            {showPopup && (
                <div className="popup-overlay">
                    <div className="popup-content">
                        <span className="close-btn" onClick={() => setShowPopup(false)}>&times;</span>

                        {step === 1 ? (
                            <div className="form-step">
                                <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: 'orange' }}>Enter your details</h2>
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                />
                                <input
                                    type="tel"
                                    name="phone"
                                    placeholder="Phone Number"
                                    value={formData.phone}
                                    onChange={handleInputChange}
                                />
                                <button onClick={handleSubmit}>Submit</button>
                            </div>
                        ) : (
                            <div className="form-step">
                                <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: 'orange' }}>Confirm Your Details</h2>
                                <p style={{ color: 'black', textAlign: 'left', fontFamily: 'sans-serif' }}><strong>Email:</strong> {formData.email}</p>
                                <p style={{ color: 'black', textAlign: 'left', fontFamily: 'sans-serif' }}><strong>Phone:</strong> {formData.phone}</p>
                                <hr />
                                <p style={{ color: 'blue', textAlign: 'left', fontFamily: 'sans-serif' }}><strong>Course:</strong> {courseDetails.name}</p>
                                <p style={{ color: 'blue', textAlign: 'left', fontFamily: 'sans-serif' }}><strong>Description:</strong> {courseDetails.description}</p>
                                <p style={{ color: 'blue', textAlign: 'left', fontFamily: 'sans-serif' }}><strong>Fee:</strong> {courseDetails.fee}</p>
                                {/* <button className="pay-btn">Pay Now</button> */}
                                <button
                                    className="pay-btn" onClick={initiatePayment} disabled={loading}>
                                    {loading ? 'Processing...' : 'Pay Now'}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            )}
            <div style={{ marginTop: '-292px' }}>
                <OnlyButtonrange />
            </div>
        </>
    );
};

export default Banner;








